import styled, { css } from 'styled-components'
import { ReactComponent as ExclamationMarkIcon } from '@sketch/icons/exclamation-mark-triangle-64'
import { ItemName, ItemImageWrapper, ListGridItem } from '../../components/Grid'
import { VersionLink } from '../../../../versioning'

export const MissingListGridItem = styled(ListGridItem)`
  cursor: not-allowed;
`

export const MissingFrameIcon = styled(ExclamationMarkIcon)`
  margin-bottom: 8px;
  opacity: 0.3;
  width: 64px;
  color: ${({ theme }) => theme.colors.foreground.secondary.A};
`

export const MissingItemName = styled(ItemName)`
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
`

export const VersionLinkStyled = styled(VersionLink)(
  ({ theme }) => css`
    /* stylelint-disable-next-line selector-type-no-unknown */
    ${ItemImageWrapper}:hover {
      background-color: ${theme.colors.background.tertiary.C};
    }
  `
)
